import { SupportedCustomerType } from 'APIs/marketplaces/marketplaces.general.settings.types';
import { MerchantPersonRole } from 'APIs/merchant.persons/merchant.persons.types';

export const baseUri = '/admin-dashboard';

export const enterpriseSlugs = ['enterpriselimepay', 'enterprisespenda', 'apgpay'];

export const journalEntryTypes = [
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'bank_transfer_reversal', label: 'Bank Transfer Reversal' },
  { value: 'bank_transfer_fixed_fee', label: 'Bank Transfer Fixed Fee' },
  { value: 'card_charge', label: 'Card Charge' },
  { value: 'card_charge_reversal', label: 'Card Charge Reversal' },
  { value: 'card_charge_fixed_fee', label: 'Card Charge Fixed Fee' },
  { value: 'card_charge_variable_fee', label: 'Card Charge Variable Fee' },
  { value: 'card_charge_interchange_fee', label: 'Card Charge Interchange Fee' },
  { value: 'customer_payment', label: 'Customer Payment' },
  { value: 'direct_debit', label: 'Direct Debit' },
  { value: 'direct_debit_reversal', label: 'Direct Debit Reversal' },
  { value: 'direct_debit_fixed_fee', label: 'Direct Debit Fixed Fee' },
  { value: 'disbursement', label: 'Disbursement' },
  { value: 'disbursement_fixed_fee', label: 'Disbursement Fixed Fee' },
  { value: 'disbursement_reversal', label: 'Disbursement Reversal' },
  { value: 'disbursement_variable_fee', label: 'Disbursement Variable Fee' },
  { value: 'dispute', label: 'Dispute' },
  { value: 'dispute_fee', label: 'Dispute Fee' },
  { value: 'dispute_reversal', label: 'Dispute Reversal' },
  { value: 'dispute_fee_reversal', label: 'Dispute Fee Reversal' },
  { value: 'journal_clearance', label: 'Journal Clearance' },
  { value: 'invoice_credit', label: 'Invoice Credit' },
  { value: 'invoice_payment', label: 'Invoice Payment' },
  { value: 'loan_drawdown_auth', label: 'Loan Drawdown Auth' },
  { value: 'loan_drawdown_capture', label: 'Loan Drawdown Capture' },
  { value: 'loan_drawdown_cancel', label: 'Loan Drawdown Cancel' },
  { value: 'loan_drawdown_refund', label: 'Loan Drawdown Refund' },
  { value: 'loan_late_fee', label: 'Loan Late Fee' },
  { value: 'loan_interest', label: 'Loan Interest' },
  { value: 'loan_repayment', label: 'Loan Repayment' },
  { value: 'loan_variable_fee', label: 'Loan Variable Fee' },
  { value: 'manual_top_up', label: 'Manual Top Up' },
  { value: 'manual_top_up_reversal', label: 'Manual Top Up Reversal' },
  { value: 'marketplace_fee', label: 'Marketplace Fee' },
  { value: 'merchant_service_fee', label: 'Merchant Service Fee' },
  { value: 'origination_fee', label: 'Origination Fee' },
  { value: 'payment', label: 'Payment' },
  { value: 'payment_fee', label: 'Payment Fee' },
  { value: 'payment_fee_reversal', label: 'Payment Fee Reversal' },
  { value: 'payout_fee', label: 'Payout Fee' },
  { value: 'refund', label: 'Refund' },
  { value: 'refund_fee', label: 'Refund Fee' },
  { value: 'transaction_transfer', label: 'Transaction Transfer' },
  { value: 'transaction_transfer_fee_reversal', label: 'Transaction Transfer Fee Reversal' },
  { value: 'transaction_transfer_reversal', label: 'Transaction Transfer Reversal' },
  { value: 'surcharge', label: 'Surcharge' },
];

export const journaleEntryCategories = [
  { value: 'general', label: 'General' },
  { value: 'income', label: 'Income' },
  { value: 'fees', label: 'Fees' },
  { value: 'disputes', label: 'Disputes' },
  { value: 'reserved', label: 'Reserved' },
  { value: 'income_realtime', label: 'Income Realtime' },
  { value: 'fees_realtime', label: 'Fees Realtime' },
  { value: 'disputes_realtime', label: 'Disputes Realtime' },
  { value: 'general_ledger', label: 'General Ledger' },
  { value: 'net_ledger', label: 'Net Ledger' },
  { value: 'income_ledger', label: 'Income Ledger' },
  { value: 'fees_ledger', label: 'Fees Ledger' },
  { value: 'disputes_ledger', label: 'Disputes Ledger' },
  { value: 'reserved_ledger', label: 'Reserved Ledger' },
];

export const invoiceStatuses = [
  { value: 'draft', label: 'Draft' },
  { value: 'outstanding', label: 'Outstanding' },
  // { value: 'near_due', label: 'Near Due' },
  // { value: 'due', label: 'Due' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'paid', label: 'Paid' },
  { value: 'cancelled', label: 'Cancelled' },
  // { value: 'defaulted', label: 'Defaulted' },
];

export const merchantBusinessTypes = [
  { value: 'individual', label: 'Individual' },
  { value: 'company', label: 'Company' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'trust', label: 'Trust' },
  { value: 'soletrader', label: 'Non Sole trader' },
];

export const merchantCompanyTypes = [
  { value: 'Private', label: 'Private' },
  { value: 'Public', label: 'Public' },
];

export const merchantIndustries = [
  {
    value: 'AcRefrigerationRepair',
    label: 'Ac Refrigeration Repair',
  },
  {
    value: 'AccountingBookkeepingServices',
    label: 'Accounting Bookkeeping Services',
  },
  {
    value: 'AdvertisingServices',
    label: 'Advertising Services',
  },
  {
    value: 'AgriculturalCooperative',
    label: 'Agricultural Cooperative',
  },
  {
    value: 'AirlinesAirCarriers',
    label: 'Airlines Air Carriers',
  },
  {
    value: 'AirportsFlyingFields',
    label: 'Airports Flying Fields',
  },
  {
    value: 'AmbulanceServices',
    label: 'Ambulance Services',
  },
  {
    value: 'AmusementParksCarnivals',
    label: 'Amusement Parks Carnivals',
  },
  {
    value: 'AntiqueReproductions',
    label: 'Antique Reproductions',
  },
  {
    value: 'AntiqueShops',
    label: 'Antique Shops',
  },
  {
    value: 'Aquariums',
    label: 'Aquariums',
  },
  {
    value: 'ArchitecturalSurveyingServices',
    label: 'Architectural Surveying Services',
  },
  {
    value: 'ArtDealersAndGalleries',
    label: 'Art Dealers And Galleries',
  },
  {
    value: 'ArtistsSupplyAndCraftShops',
    label: 'Artists Supply And Craft Shops',
  },
  {
    value: 'AutoAndHomeSupplyStores',
    label: 'Auto And Home Supply Stores',
  },
  {
    value: 'AutoBodyRepairShops',
    label: 'Auto Body Repair Shops',
  },
  {
    value: 'AutoPaintShops',
    label: 'Auto Paint Shops',
  },
  {
    value: 'AutoServiceShops',
    label: 'Auto Service Shops',
  },
  {
    value: 'AutomatedCashDisburse',
    label: 'Automated Cash Disburse',
  },
  {
    value: 'AutomatedFuelDispensers',
    label: 'Automated Fuel Dispensers',
  },
  {
    value: 'AutomobileAssociations',
    label: 'Automobile Associations',
  },
  {
    value: 'AutomotivePartsAndAccessoriesStores',
    label: 'Automotive Parts And Accessories Stores',
  },
  {
    value: 'AutomotiveTireStores',
    label: 'Automotive Tire Stores',
  },
  {
    value: 'BailAndBondPayments',
    label: 'Bail And Bond Payments',
  },
  {
    value: 'Bakeries',
    label: 'Bakeries',
  },
  {
    value: 'BandsOrchestras',
    label: 'Bands Orchestras',
  },
  {
    value: 'BarberAndBeautyShops',
    label: 'Barber And Beauty Shops',
  },
  {
    value: 'BettingCasinoGambling',
    label: 'Betting Casino Gambling',
  },
  {
    value: 'BicycleShops',
    label: 'Bicycle Shops',
  },
  {
    value: 'BilliardPoolEstablishments',
    label: 'Billiard Pool Establishments',
  },
  {
    value: 'BoatDealers',
    label: 'Boat Dealers',
  },
  {
    value: 'BoatRentalsAndLeases',
    label: 'Boat Rentals And Leases',
  },
  {
    value: 'BookStores',
    label: 'Book Stores',
  },
  {
    value: 'BooksPeriodicalsAndNewspapers',
    label: 'Books Periodicals And Newspapers',
  },
  {
    value: 'BowlingAlleys',
    label: 'Bowling Alleys',
  },
  {
    value: 'BusLines',
    label: 'Bus Lines',
  },
  {
    value: 'BusinessSecretarialSchools',
    label: 'Business Secretarial Schools',
  },
  {
    value: 'BuyingShoppingServices',
    label: 'Buying Shopping Services',
  },
  {
    value: 'CableSatelliteAndOtherPayTelevisionAndRadio',
    label: 'Cable Satellite And Other Pay Television And Radio',
  },
  {
    value: 'CameraAndPhotographicSupplyStores',
    label: 'Camera And Photographic Supply Stores',
  },
  {
    value: 'CandyNutAndConfectioneryStores',
    label: 'Candy Nut And Confectionery Stores',
  },
  {
    value: 'CarAndTruckDealersNewUsed',
    label: 'Car And Truck Dealers New Used',
  },
  {
    value: 'CarAndTruckDealersUsedOnly',
    label: 'Car And Truck Dealers Used Only',
  },
  {
    value: 'CarRentalAgencies',
    label: 'Car Rental Agencies',
  },
  {
    value: 'CarWashes',
    label: 'Car Washes',
  },
  {
    value: 'CarpentryServices',
    label: 'Carpentry Services',
  },
  {
    value: 'CarpetUpholsteryCleaning',
    label: 'Carpet Upholstery Cleaning',
  },
  {
    value: 'Caterers',
    label: 'Caterers',
  },
  {
    value: 'CharitableAndSocialServiceOrganizationsFundraising',
    label: 'Charitable And Social Service Organizations Fundraising',
  },
  {
    value: 'ChemicalsAndAlliedProducts',
    label: 'Chemicals And Allied Products',
  },
  {
    value: 'ChildCareServices',
    label: 'Child Care Services',
  },
  {
    value: 'ChildrensAndInfantsWearStores',
    label: 'Childrens And Infants Wear Stores',
  },
  {
    value: 'ChiropodistsPodiatrists',
    label: 'Chiropodists Podiatrists',
  },
  {
    value: 'Chiropractors',
    label: 'Chiropractors',
  },
  {
    value: 'CigarStoresAndStands',
    label: 'Cigar Stores And Stands',
  },
  {
    value: 'CivicSocialFraternalAssociations',
    label: 'Civic Social Fraternal Associations',
  },
  {
    value: 'CleaningAndMaintenance',
    label: 'Cleaning And Maintenance',
  },
  {
    value: 'ClothingRental',
    label: 'Clothing Rental',
  },
  {
    value: 'CollegesUniversities',
    label: 'Colleges Universities',
  },
  {
    value: 'CommercialEquipment',
    label: 'Commercial Equipment',
  },
  {
    value: 'CommercialFootwear',
    label: 'Commercial Footwear',
  },
  {
    value: 'CommercialPhotographyArtAndGraphics',
    label: 'Commercial Photography Art And Graphics',
  },
  {
    value: 'CommuterTransportAndFerries',
    label: 'Commuter Transport And Ferries',
  },
  {
    value: 'ComputerNetworkServices',
    label: 'Computer Network Services',
  },
  {
    value: 'ComputerProgramming',
    label: 'Computer Programming',
  },
  {
    value: 'ComputerRepair',
    label: 'Computer Repair',
  },
  {
    value: 'ComputerSoftwareStores',
    label: 'Computer Software Stores',
  },
  {
    value: 'ComputersPeripheralsAndSoftware',
    label: 'Computers Peripherals And Software',
  },
  {
    value: 'ConcreteWorkServices',
    label: 'Concrete Work Services',
  },
  {
    value: 'ConstructionMaterials',
    label: 'Construction Materials',
  },
  {
    value: 'ConsultingPublicRelations',
    label: 'Consulting Public Relations',
  },
  {
    value: 'CorrespondenceSchools',
    label: 'Correspondence Schools',
  },
  {
    value: 'CosmeticStores',
    label: 'Cosmetic Stores',
  },
  {
    value: 'CounselingServices',
    label: 'Counseling Services',
  },
  {
    value: 'CountryClubs',
    label: 'Country Clubs',
  },
  {
    value: 'CourierServices',
    label: 'Courier Services',
  },
  {
    value: 'CourtCosts',
    label: 'Court Costs',
  },
  {
    value: 'CreditReportingAgencies',
    label: 'Credit Reporting Agencies',
  },
  {
    value: 'CruiseLines',
    label: 'Cruise Lines',
  },
  {
    value: 'DairyProductsStores',
    label: 'Dairy Products Stores',
  },
  {
    value: 'DanceHallStudiosSchools',
    label: 'Dance Hall Studios Schools',
  },
  {
    value: 'DatingEscortServices',
    label: 'Dating Escort Services',
  },
  {
    value: 'DentistsOrthodontists',
    label: 'Dentists Orthodontists',
  },
  {
    value: 'DepartmentStores',
    label: 'Department Stores',
  },
  {
    value: 'DetectiveAgencies',
    label: 'Detective Agencies',
  },
  {
    value: 'DigitalGoodsApplications',
    label: 'Digital Goods Applications',
  },
  {
    value: 'DigitalGoodsGames',
    label: 'Digital Goods Games',
  },
  {
    value: 'DigitalGoodsLargeVolume',
    label: 'Digital Goods Large Volume',
  },
  {
    value: 'DigitalGoodsMedia',
    label: 'Digital Goods Media',
  },
  {
    value: 'DirectMarketingCatalogMerchant',
    label: 'Direct Marketing Catalog Merchant',
  },
  {
    value: 'DirectMarketingCombinationCatalogAndRetailMerchant',
    label: 'Direct Marketing Combination Catalog And Retail Merchant',
  },
  {
    value: 'DirectMarketingInboundTelemarketing',
    label: 'Direct Marketing Inbound Telemarketing',
  },
  {
    value: 'DirectMarketingInsuranceServices',
    label: 'Direct Marketing Insurance Services',
  },
  {
    value: 'DirectMarketingOther',
    label: 'Direct Marketing Other',
  },
  {
    value: 'DirectMarketingOutboundTelemarketing',
    label: 'Direct Marketing Outbound Telemarketing',
  },
  {
    value: 'DirectMarketingSubscription',
    label: 'Direct Marketing Subscription',
  },
  {
    value: 'DirectMarketingTravel',
    label: 'Direct Marketing Travel',
  },
  {
    value: 'DiscountStores',
    label: 'Discount Stores',
  },
  {
    value: 'Doctors',
    label: 'Doctors',
  },
  {
    value: 'DoorToDoorSales',
    label: 'Door To Door Sales',
  },
  {
    value: 'DraperyWindowCoveringAndUpholsteryStores',
    label: 'Drapery Window Covering And Upholstery Stores',
  },
  {
    value: 'DrinkingPlaces',
    label: 'Drinking Places',
  },
  {
    value: 'DrugStoresAndPharmacies',
    label: 'Drug Stores And Pharmacies',
  },
  {
    value: 'DrugsDrugProprietariesAndDruggistSundries',
    label: 'Drugs Drug Proprietaries And Druggist Sundries',
  },
  {
    value: 'DryCleaners',
    label: 'Dry Cleaners',
  },
  {
    value: 'DurableGoods',
    label: 'Durable Goods',
  },
  {
    value: 'DutyFreeStores',
    label: 'Duty Free Stores',
  },
  {
    value: 'EatingPlacesRestaurants',
    label: 'Eating Places Restaurants',
  },
  {
    value: 'EducationalServices',
    label: 'Educational Services',
  },
  {
    value: 'ElectricRazorStores',
    label: 'Electric Razor Stores',
  },
  {
    value: 'ElectricalPartsAndEquipment',
    label: 'Electrical Parts And Equipment',
  },
  {
    value: 'ElectricalServices',
    label: 'Electrical Services',
  },
  {
    value: 'ElectronicsRepairShops',
    label: 'Electronics Repair Shops',
  },
  {
    value: 'ElectronicsStores',
    label: 'Electronics Stores',
  },
  {
    value: 'ElementarySecondarySchools',
    label: 'Elementary Secondary Schools',
  },
  {
    value: 'EmploymentTempAgencies',
    label: 'Employment Temp Agencies',
  },
  {
    value: 'EquipmentRental',
    label: 'Equipment Rental',
  },
  {
    value: 'ExterminatingServices',
    label: 'Exterminating Services',
  },
  {
    value: 'FamilyClothingStores',
    label: 'Family Clothing Stores',
  },
  {
    value: 'FastFoodRestaurants',
    label: 'Fast Food Restaurants',
  },
  {
    value: 'FinancialInstitutions',
    label: 'Financial Institutions',
  },
  {
    value: 'FinesGovernmentAdministrativeEntities',
    label: 'Fines Government Administrative Entities',
  },
  {
    value: 'FireplaceFireplaceScreensAndAccessoriesStores',
    label: 'Fireplace Fireplace Screens And Accessories Stores',
  },
  {
    value: 'FloorCoveringStores',
    label: 'Floor Covering Stores',
  },
  {
    value: 'Florists',
    label: 'Florists',
  },
  {
    value: 'FloristsSuppliesNurseryStockAndFlowers',
    label: 'Florists Supplies Nursery Stock And Flowers',
  },
  {
    value: 'FreezerAndLockerMeatProvisioners',
    label: 'Freezer And Locker Meat Provisioners',
  },
  {
    value: 'FuelDealersNonAutomotive',
    label: 'Fuel Dealers Non Automotive',
  },
  {
    value: 'FuneralServicesCrematories',
    label: 'Funeral Services Crematories',
  },
  {
    value: 'FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances',
    label: 'Furniture Home Furnishings And Equipment Stores Except Appliances',
  },
  {
    value: 'FurnitureRepairRefinishing',
    label: 'Furniture Repair Refinishing',
  },
  {
    value: 'FurriersAndFurShops',
    label: 'Furriers And Fur Shops',
  },
  {
    value: 'GeneralServices',
    label: 'General Services',
  },
  {
    value: 'GiftCardNoveltyAndSouvenirShops',
    label: 'Gift Card Novelty And Souvenir Shops',
  },
  {
    value: 'GlassPaintAndWallpaperStores',
    label: 'Glass Paint And Wallpaper Stores',
  },
  {
    value: 'GlasswareCrystalStores',
    label: 'Glassware Crystal Stores',
  },
  {
    value: 'GolfCoursesPublic',
    label: 'Golf Courses Public',
  },
  {
    value: 'GovernmentServices',
    label: 'Government Services',
  },
  {
    value: 'GroceryStoresSupermarkets',
    label: 'Grocery Stores Supermarkets',
  },
  {
    value: 'HardwareEquipmentAndSupplies',
    label: 'Hardware Equipment And Supplies',
  },
  {
    value: 'HardwareStores',
    label: 'Hardware Stores',
  },
  {
    value: 'HealthAndBeautySpas',
    label: 'Health And Beauty Spas',
  },
  {
    value: 'HearingAidsSalesAndSupplies',
    label: 'Hearing Aids Sales And Supplies',
  },
  {
    value: 'HeatingPlumbingAC',
    label: 'Heating Plumbing A C',
  },
  {
    value: 'HobbyToyAndGameShops',
    label: 'Hobby Toy And Game Shops',
  },
  {
    value: 'HomeSupplyWarehouseStores',
    label: 'Home Supply Warehouse Stores',
  },
  {
    value: 'Hospitals',
    label: 'Hospitals',
  },
  {
    value: 'HotelsMotelsAndResorts',
    label: 'Hotels Motels And Resorts',
  },
  {
    value: 'HouseholdApplianceStores',
    label: 'Household Appliance Stores',
  },
  {
    value: 'IndustrialSupplies',
    label: 'Industrial Supplies',
  },
  {
    value: 'InformationRetrievalServices',
    label: 'Information Retrieval Services',
  },
  {
    value: 'InsuranceDefault',
    label: 'Insurance Default',
  },
  {
    value: 'InsuranceUnderwritingPremiums',
    label: 'Insurance Underwriting Premiums',
  },
  {
    value: 'IntraCompanyPurchases',
    label: 'Intra Company Purchases',
  },
  {
    value: 'JewelryStoresWatchesClocksAndSilverwareStores',
    label: 'Jewelry Stores Watches Clocks And Silverware Stores',
  },
  {
    value: 'LandscapingServices',
    label: 'Landscaping Services',
  },
  {
    value: 'Laundries',
    label: 'Laundries',
  },
  {
    value: 'LaundryCleaningServices',
    label: 'Laundry Cleaning Services',
  },
  {
    value: 'LegalServicesAttorneys',
    label: 'Legal Services Attorneys',
  },
  {
    value: 'LuggageAndLeatherGoodsStores',
    label: 'Luggage And Leather Goods Stores',
  },
  {
    value: 'LumberBuildingMaterialsStores',
    label: 'Lumber Building Materials Stores',
  },
  {
    value: 'ManualCashDisburse',
    label: 'Manual Cash Disburse',
  },
  {
    value: 'MarinasServiceAndSupplies',
    label: 'Marinas Service And Supplies',
  },
  {
    value: 'MasonryStoneworkAndPlaster',
    label: 'Masonry Stonework And Plaster',
  },
  {
    value: 'MassageParlors',
    label: 'Massage Parlors',
  },
  {
    value: 'MedicalAndDentalLabs',
    label: 'Medical And Dental Labs',
  },
  {
    value: 'MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies',
    label: 'Medical Dental Ophthalmic And Hospital Equipment And Supplies',
  },
  {
    value: 'MedicalServices',
    label: 'Medical Services',
  },
  {
    value: 'MembershipOrganizations',
    label: 'Membership Organizations',
  },
  {
    value: 'MensAndBoysClothingAndAccessoriesStores',
    label: 'Mens And Boys Clothing And Accessories Stores',
  },
  {
    value: 'MensWomensClothingStores',
    label: 'Mens Womens Clothing Stores',
  },
  {
    value: 'MetalServiceCenters',
    label: 'Metal Service Centers',
  },
  {
    value: 'MiscellaneousApparelAndAccessoryShops',
    label: 'Miscellaneous Apparel And Accessory Shops',
  },
  {
    value: 'MiscellaneousAutoDealers',
    label: 'Miscellaneous Auto Dealers',
  },
  {
    value: 'MiscellaneousBusinessServices',
    label: 'Miscellaneous Business Services',
  },
  {
    value: 'MiscellaneousFoodStores',
    label: 'Miscellaneous Food Stores',
  },
  {
    value: 'MiscellaneousGeneralMerchandise',
    label: 'Miscellaneous General Merchandise',
  },
  {
    value: 'MiscellaneousGeneralServices',
    label: 'Miscellaneous General Services',
  },
  {
    value: 'MiscellaneousHomeFurnishingSpecialtyStores',
    label: 'Miscellaneous Home Furnishing Specialty Stores',
  },
  {
    value: 'MiscellaneousPublishingAndPrinting',
    label: 'Miscellaneous Publishing And Printing',
  },
  {
    value: 'MiscellaneousRecreationServices',
    label: 'Miscellaneous Recreation Services',
  },
  {
    value: 'MiscellaneousRepairShops',
    label: 'Miscellaneous Repair Shops',
  },
  {
    value: 'MiscellaneousSpecialtyRetail',
    label: 'Miscellaneous Specialty Retail',
  },
  {
    value: 'MobileHomeDealers',
    label: 'Mobile Home Dealers',
  },
  {
    value: 'MotionPictureTheaters',
    label: 'Motion Picture Theaters',
  },
  {
    value: 'MotorFreightCarriersAndTrucking',
    label: 'Motor Freight Carriers And Trucking',
  },
  {
    value: 'MotorHomesDealers',
    label: 'Motor Homes Dealers',
  },
  {
    value: 'MotorVehicleSuppliesAndNewParts',
    label: 'Motor Vehicle Supplies And New Parts',
  },
  {
    value: 'MotorcycleShopsAndDealers',
    label: 'Motorcycle Shops And Dealers',
  },
  {
    value: 'MotorcycleShopsDealers',
    label: 'Motorcycle Shops Dealers',
  },
  {
    value: 'MusicStoresMusicalInstrumentsPianosAndSheetMusic',
    label: 'Music Stores Musical Instruments Pianos And Sheet Music',
  },
  {
    value: 'NewsDealersAndNewsstands',
    label: 'News Dealers And Newsstands',
  },
  {
    value: 'NonFiMoneyOrders',
    label: 'Non Fi Money Orders',
  },
  {
    value: 'NonFiStoredValueCardPurchaseLoad',
    label: 'Non Fi Stored Value Card Purchase Load',
  },
  {
    value: 'NondurableGoods',
    label: 'Nondurable Goods',
  },
  {
    value: 'NurseriesLawnAndGardenSupplyStores',
    label: 'Nurseries Lawn And Garden Supply Stores',
  },
  {
    value: 'NursingPersonalCare',
    label: 'Nursing Personal Care',
  },
  {
    value: 'OfficeAndCommercialFurniture',
    label: 'Office And Commercial Furniture',
  },
  {
    value: 'OpticiansEyeglasses',
    label: 'Opticians Eyeglasses',
  },
  {
    value: 'OptometristsOphthalmologist',
    label: 'Optometrists Ophthalmologist',
  },
  {
    value: 'OrthopedicGoodsProstheticDevices',
    label: 'Orthopedic Goods Prosthetic Devices',
  },
  {
    value: 'Osteopaths',
    label: 'Osteopaths',
  },
  {
    value: 'PackageStoresBeerWineAndLiquor',
    label: 'Package Stores Beer Wine And Liquor',
  },
  {
    value: 'PaintsVarnishesAndSupplies',
    label: 'Paints Varnishes And Supplies',
  },
  {
    value: 'ParkingLotsGarages',
    label: 'Parking Lots Garages',
  },
  {
    value: 'PassengerRailways',
    label: 'Passenger Railways',
  },
  {
    value: 'PawnShops',
    label: 'Pawn Shops',
  },
  {
    value: 'PetShopsPetFoodAndSupplies',
    label: 'Pet Shops Pet Food And Supplies',
  },
  {
    value: 'PetroleumAndPetroleumProducts',
    label: 'Petroleum And Petroleum Products',
  },
  {
    value: 'PhotoDeveloping',
    label: 'Photo Developing',
  },
  {
    value: 'PhotographicPhotocopyMicrofilmEquipmentAndSupplies',
    label: 'Photographic Photocopy Microfilm Equipment And Supplies',
  },
  {
    value: 'PhotographicStudios',
    label: 'Photographic Studios',
  },
  {
    value: 'PictureVideoProduction',
    label: 'Picture Video Production',
  },
  {
    value: 'PieceGoodsNotionsAndOtherDryGoods',
    label: 'Piece Goods Notions And Other Dry Goods',
  },
  {
    value: 'PlumbingHeatingEquipmentAndSupplies',
    label: 'Plumbing Heating Equipment And Supplies',
  },
  {
    value: 'PoliticalOrganizations',
    label: 'Political Organizations',
  },
  {
    value: 'PostalServicesGovernmentOnly',
    label: 'Postal Services Government Only',
  },
  {
    value: 'PreciousStonesAndMetalsWatchesAndJewelry',
    label: 'Precious Stones And Metals Watches And Jewelry',
  },
  {
    value: 'ProfessionalServices',
    label: 'Professional Services',
  },
  {
    value: 'PublicWarehousingAndStorage',
    label: 'Public Warehousing And Storage',
  },
  {
    value: 'QuickCopyReproAndBlueprint',
    label: 'Quick Copy Repro And Blueprint',
  },
  {
    value: 'Railroads',
    label: 'Railroads',
  },
  {
    value: 'RealEstateAgentsAndManagersRentals',
    label: 'Real Estate Agents And Managers Rentals',
  },
  {
    value: 'RecordStores',
    label: 'Record Stores',
  },
  {
    value: 'RecreationalVehicleRentals',
    label: 'Recreational Vehicle Rentals',
  },
  {
    value: 'ReligiousGoodsStores',
    label: 'Religious Goods Stores',
  },
  {
    value: 'ReligiousOrganizations',
    label: 'Religious Organizations',
  },
  {
    value: 'RoofingSidingSheetMetal',
    label: 'Roofing Siding Sheet Metal',
  },
  {
    value: 'SecretarialSupportServices',
    label: 'Secretarial Support Services',
  },
  {
    value: 'SecurityBrokersDealers',
    label: 'Security Brokers Dealers',
  },
  {
    value: 'ServiceStations',
    label: 'Service Stations',
  },
  {
    value: 'SewingNeedleworkFabricAndPieceGoodsStores',
    label: 'Sewing Needlework Fabric And Piece Goods Stores',
  },
  {
    value: 'ShoeRepairHatCleaning',
    label: 'Shoe Repair Hat Cleaning',
  },
  {
    value: 'ShoeStores',
    label: 'Shoe Stores',
  },
  {
    value: 'SmallApplianceRepair',
    label: 'Small Appliance Repair',
  },
  {
    value: 'SnowmobileDealers',
    label: 'Snowmobile Dealers',
  },
  {
    value: 'SpecialTradeServices',
    label: 'Special Trade Services',
  },
  {
    value: 'SpecialtyCleaning',
    label: 'Specialty Cleaning',
  },
  {
    value: 'SportingGoodsStores',
    label: 'Sporting Goods Stores',
  },
  {
    value: 'SportingRecreationCamps',
    label: 'Sporting Recreation Camps',
  },
  {
    value: 'SportsAndRidingApparelStores',
    label: 'Sports And Riding Apparel Stores',
  },
  {
    value: 'SportsClubsFields',
    label: 'Sports Clubs Fields',
  },
  {
    value: 'StampAndCoinStores',
    label: 'Stamp And Coin Stores',
  },
  {
    value: 'StationaryOfficeSuppliesPrintingAndWritingPaper',
    label: 'Stationary Office Supplies Printing And Writing Paper',
  },
  {
    value: 'StationeryStoresOfficeAndSchoolSupplyStores',
    label: 'Stationery Stores Office And School Supply Stores',
  },
  {
    value: 'SwimmingPoolsSales',
    label: 'Swimming Pools Sales',
  },
  {
    value: 'TUiTravelGermany',
    label: 'T Ui Travel Germany',
  },
  {
    value: 'TailorsAlterations',
    label: 'Tailors Alterations',
  },
  {
    value: 'TaxPaymentsGovernmentAgencies',
    label: 'Tax Payments Government Agencies',
  },
  {
    value: 'TaxPreparationServices',
    label: 'Tax Preparation Services',
  },
  {
    value: 'TaxicabsLimousines',
    label: 'Taxicabs Limousines',
  },
  {
    value: 'TelecommunicationEquipmentAndTelephoneSales',
    label: 'Telecommunication Equipment And Telephone Sales',
  },
  {
    value: 'TelecommunicationServices',
    label: 'Telecommunication Services',
  },
  {
    value: 'TelegraphServices',
    label: 'Telegraph Services',
  },
  {
    value: 'TentAndAwningShops',
    label: 'Tent And Awning Shops',
  },
  {
    value: 'TestingLaboratories',
    label: 'Testing Laboratories',
  },
  {
    value: 'TheatricalTicketAgencies',
    label: 'Theatrical Ticket Agencies',
  },
  {
    value: 'Timeshares',
    label: 'Timeshares',
  },
  {
    value: 'TireRetreadingAndRepair',
    label: 'Tire Retreading And Repair',
  },
  {
    value: 'TollsBridgeFees',
    label: 'Tolls Bridge Fees',
  },
  {
    value: 'TouristAttractionsAndExhibits',
    label: 'Tourist Attractions And Exhibits',
  },
  {
    value: 'TowingServices',
    label: 'Towing Services',
  },
  {
    value: 'TrailerParksCampgrounds',
    label: 'Trailer Parks Campgrounds',
  },
  {
    value: 'TransportationServices',
    label: 'Transportation Services',
  },
  {
    value: 'TravelAgenciesTourOperators',
    label: 'Travel Agencies Tour Operators',
  },
  {
    value: 'TruckStopIteration',
    label: 'Truck Stop Iteration',
  },
  {
    value: 'TruckUtilityTrailerRentals',
    label: 'Truck Utility Trailer Rentals',
  },
  {
    value: 'TypesettingPlateMakingAndRelatedServices',
    label: 'Typesetting Plate Making And Related Services',
  },
  {
    value: 'TypewriterStores',
    label: 'Typewriter Stores',
  },
  {
    value: 'USFederalGovernmentAgenciesOrDepartments',
    label: 'U S Federal Government Agencies Or Departments',
  },
  {
    value: 'UniformsCommercialClothing',
    label: 'Uniforms Commercial Clothing',
  },
  {
    value: 'UsedMerchandiseAndSecondhandStores',
    label: 'Used Merchandise And Secondhand Stores',
  },
  {
    value: 'Utilities',
    label: 'Utilities',
  },
  {
    value: 'VarietyStores',
    label: 'Variety Stores',
  },
  {
    value: 'VeterinaryServices',
    label: 'Veterinary Services',
  },
  {
    value: 'VideoAmusementGameSupplies',
    label: 'Video Amusement Game Supplies',
  },
  {
    value: 'VideoGameArcades',
    label: 'Video Game Arcades',
  },
  {
    value: 'VideoTapeRentalStores',
    label: 'Video Tape Rental Stores',
  },
  {
    value: 'VocationalTradeSchools',
    label: 'Vocational Trade Schools',
  },
  {
    value: 'WatchJewelryRepair',
    label: 'Watch Jewelry Repair',
  },
  {
    value: 'WeldingRepair',
    label: 'Welding Repair',
  },
  {
    value: 'WholesaleClubs',
    label: 'Wholesale Clubs',
  },
  {
    value: 'WigAndToupeeStores',
    label: 'Wig And Toupee Stores',
  },
  {
    value: 'WiresMoneyOrders',
    label: 'Wires Money Orders',
  },
  {
    value: 'WomensAccessoryAndSpecialtyShops',
    label: 'Womens Accessory And Specialty Shops',
  },
  {
    value: 'WomensReadyToWearStores',
    label: 'Womens Ready To Wear Stores',
  },
  {
    value: 'WreckingAndSalvageYards',
    label: 'Wrecking And Salvage Yards',
  },
];

export const countries = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'US', label: 'United States' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'SG', label: 'Singapore' },
  { value: 'ZA', label: 'South Africa' },
];

export const tradingCountries = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'US', label: 'United States' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'SG', label: 'Singapore' },
  { value: 'ZA', label: 'South Africa' },
];

export const merchantTimeZones = [
  'Australia/Sydney',
  'Australia/Brisbane',
  'Australia/Melbourne',
  'Australia/Perth',
  'Pacific/Auckland',
];

export const merchantTaxCountries = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'US', label: 'United States' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'SG', label: 'Singapore' },
  { value: 'ZA', label: 'South Africa' },
];

export const merchantDocsAllowedFileTypes = ['pdf', 'jpeg', 'jpg', 'png'];

export const merchantUserRoles = [
  { value: 'admin', label: 'Admin' },
  { value: 'support', label: 'Support' },
];

export const marketplaceUserRoles = [
  { value: 'Admin', label: 'Admin' },
  { value: 'Support', label: 'Support' },
];

export const merchantPersonRoles = [
  { value: 'Executive' as MerchantPersonRole, label: 'Executive' },
  { value: 'Owner' as MerchantPersonRole, label: 'Owner' },
  { value: 'Director' as MerchantPersonRole, label: 'Director' },
];

export const countryStatesRegions = {
  AU: [
    { value: 'ACT', label: 'Australian Capital Territory' },
    { value: 'NSW', label: 'New South Wales' },
    { value: 'NT', label: 'Northern Territory' },
    { value: 'QLD', label: 'Queensland' },
    { value: 'SA', label: 'South Australia' },
    { value: 'TAS', label: 'Tasmania' },
    { value: 'VIC', label: 'Victoria' },
    { value: 'WA', label: 'Western Australia' },
  ],
  NZ: [
    { value: 'Auckland', label: 'Auckland' },
    { value: 'Bay of Plenty', label: 'Bay of Plenty' },
    { value: 'Canterbury', label: 'Canterbury' },
    { value: 'Gisborne', label: 'Gisborne' },
    { value: "Hawke's Bay", label: "Hawke's Bay" },
    { value: 'Manawatu-Wanganui', label: 'Manawatu-Wanganui' },
    { value: 'Marlborough', label: 'Marlborough' },
    { value: 'Nelson', label: 'Nelson' },
    { value: 'Northland', label: 'Northland' },
    { value: 'Otago', label: 'Otago' },
    { value: 'Southland', label: 'Southland' },
    { value: 'Taranaki', label: 'Taranaki' },
    { value: 'Tasman', label: 'Tasman' },
    { value: 'Waikato', label: 'Waikato' },
    { value: 'Wellington', label: 'Wellington' },
    { value: 'West Coast', label: 'West Coast' },
  ],
  US: [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
  ],
};

export const supportedCustomerTypes: Array<{ value: SupportedCustomerType; label: string }> = [
  { value: 'consumercustomertype', label: 'Consumer customer' },
  { value: 'organisationcustomertype', label: 'Organisation customer' },
  { value: 'marketplacecustomerproxytype', label: 'Marketplace customer proxy' },
];
